import { __extends } from "tslib";
import { NativeMenu } from '../display/NativeMenu';
import { Debug } from '@awayjs/core';
var ContextMenu = /** @class */ (function (_super) {
    __extends(ContextMenu, _super);
    function ContextMenu() {
        var _this = _super.call(this) || this;
        _this._builtInItems = new _this.sec.flash.ui.ContextMenuBuiltInItems();
        _this._customItems = [];
        _this._clipboardItems = _this.sec.flash.ui.ContextMenuClipboardItems();
        return _this;
    }
    Object.defineProperty(ContextMenu, "isSupported", {
        get: function () {
            // @todo
            Debug.throwPIR('playerglobals/ui/ContextMenu', 'isSupported', '');
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ContextMenu.prototype, "builtInItems", {
        get: function () {
            // TODO: Should clone here probably.
            // @todo
            Debug.throwPIR('playerglobals/ui/ContextMenu', 'get builtInItems', '');
            return this._builtInItems;
        },
        set: function (value) {
            // TODO: Should clone here probably.
            // @todo
            Debug.throwPIR('playerglobals/ui/ContextMenu', 'set builtInItems', '');
            this._builtInItems = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ContextMenu.prototype, "customItems", {
        get: function () {
            // TODO: Should clone here probably.
            // @todo
            Debug.throwPIR('playerglobals/ui/ContextMenu', 'get customItems', '');
            return this.sec.createArrayUnsafe(this._customItems);
        },
        set: function (value) {
            // TODO: Should clone here probably.
            // @todo
            Debug.throwPIR('playerglobals/ui/ContextMenu', 'set customItems', '');
            this._customItems = value.value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ContextMenu.prototype, "link", {
        get: function () {
            // @todo
            Debug.throwPIR('playerglobals/ui/ContextMenu', 'get link', '');
            return this._link;
        },
        set: function (value) {
            // @todo
            Debug.throwPIR('playerglobals/ui/ContextMenu', 'set link', '');
            this._link = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ContextMenu.prototype, "clipboardMenu", {
        get: function () {
            // @todo
            Debug.throwPIR('playerglobals/ui/ContextMenu', 'set clipboardMenu', '');
            return this._clipboardMenu;
        },
        set: function (value) {
            value = !!value;
            // @todo
            Debug.throwPIR('playerglobals/ui/ContextMenu', 'set clipboardMenu', '');
            this._clipboardMenu = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ContextMenu.prototype, "clipboardItems", {
        get: function () {
            // @todo
            Debug.throwPIR('playerglobals/ui/ContextMenu', 'get clipboardItems', '');
            return this._clipboardItems;
        },
        set: function (value) {
            // @todo
            Debug.throwPIR('playerglobals/ui/ContextMenu', 'set clipboardItems', '');
            this._clipboardItems = value;
        },
        enumerable: false,
        configurable: true
    });
    ContextMenu.prototype.hideBuiltInItems = function () {
        var items = this.builtInItems;
        if (!items) {
            return;
        }
        items.save = false;
        items.zoom = false;
        items.quality = false;
        items.play = false;
        items.loop = false;
        items.rewind = false;
        items.forwardAndBack = false;
        items.print = false;
    };
    ContextMenu.prototype.clone = function () {
        var result = new this.sec.flash.ui.ContextMenu();
        result._builtInItems = this._builtInItems.clone();
        this.cloneLinkAndClipboardProperties(result);
        var customItems = this._customItems;
        for (var i = 0; i < customItems.length; i++) {
            result._customItems.push(customItems[i].clone());
        }
        return result;
    };
    ContextMenu.prototype.cloneLinkAndClipboardProperties = function (c) {
        // @todo
        Debug.throwPIR('playerglobals/ui/ContextMenu', 'cloneLinkAndClipboardProperties', '');
    };
    ContextMenu.classInitializer = null;
    return ContextMenu;
}(NativeMenu));
export { ContextMenu };
